import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { FilterType } from '@/routes/webhook/tabs/event-deliveries'
import type { Dispatch, SetStateAction } from 'react'

type Props = {
  filters: FilterType
  setFilters: Dispatch<SetStateAction<FilterType>>
}

export const EventDeliveryListHeader = ({ filters, setFilters }: Props) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <Input
        autoFocus
        placeholder="Filter by ID..."
        aria-label="Filter event deliveries by ID"
        value={filters.idEvent}
        onChange={(e) =>
          setFilters((prev) => ({ ...prev, idEvent: e.target.value }))
        }
        className="max-w-sm"
      />
      <Select
        value={filters?.status || ''}
        onValueChange={(value) => {
          setFilters((prev) => ({
            ...prev,
            status: value || undefined,
          }))
        }}
      >
        <SelectTrigger className="h-8 w-[120px]" aria-label="Filter by status">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="SUCCESS">Success</SelectItem>
          <SelectItem value="FAILED">Failed</SelectItem>
          <SelectItem value="PENDING">Pending</SelectItem>
          <SelectSeparator />
          <Button
            className="w-full px-2"
            variant="secondary"
            size="sm"
            onClick={(e) => {
              e.stopPropagation()
              setFilters((prev) => ({ ...prev, status: undefined }))
            }}
          >
            Clear
          </Button>
        </SelectContent>
      </Select>
    </div>
  )
}
